import { useEffect, type ReactNode } from "react";
import { readToken } from "@/api/client";
import { BASE_URL, LOGIN_URL } from "@/config/runtime";

interface RequireAuthProps {
  children: ReactNode;
}

// O legado não tem guard de rota nenhum — quem garante autorização de verdade é
// o gateway, e a UI só esconde menu. Este componente NÃO substitui isso; é
// correção de UX: sem ele, uma rota React em bookmark com sessão expirada
// renderiza um shell vazio e dispara N requests até o interceptor do api/client
// deslogar sozinho. Aqui a checagem acontece antes de qualquer request.
//
// /login é servido pelo nginx (`location = /login` → login.html, D3). Se esse
// bloco faltar, /login cai neste app e redirecionar para LOGIN_URL de novo
// seria um loop — então ali vamos direto ao arquivo.
export function RequireAuth({ children }: RequireAuthProps) {
  useEffect(() => {
    if (!readToken()?.access_token) {
      const naPropriaRotaDeLogin = /^\/login\/?$/i.test(window.location.pathname);
      window.location.assign(naPropriaRotaDeLogin ? `${BASE_URL}/login.html` : LOGIN_URL);
    }
  }, []);

  if (!readToken()?.access_token) {
    return null;
  }

  return children;
}
